module.exports = __webpack_public_path__ + "static/peaches-931d4e842bb1a6675ad3fa8d3a9a820c.jpg";